module.exports = __webpack_public_path__ + "static/8-a861f883c5fb2971d5aa258ea3b432dd.jpeg";